import { createUseStyles } from "react-jss";
import { colors } from "../../../styles/colors";

const useStyles = createUseStyles({
  contentMain: {
    overflow: "hidden",
    height: "var(--app-vh)",
  },
  containerHeader: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 12,
    padding: "15px 0px",
  },
  vehiculeRoot: {
    padding: "30px clamp(16px, 3vw, 30px)",
    overflowY: "auto",
    height: "var(--app-vh)",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    backgroundColor: colors.bgcolor,
    /*
     * The table card absorbs the leftover height and scrolls internally, but
     * only where there IS leftover height.
     *
     * Inside a fixed-height flex column, `flex: 1 1 auto; min-height: 0` is
     * also permission to shrink to nothing. Once the filter bar stacks on a
     * narrow screen the content above exceeds the viewport, the remainder goes
     * negative, and the card collapses — leaving a search box and a pager
     * around an invisible table. That is exactly what happened on the
     * Documents page.
     */
    "@media (min-width:900px)": {
      "& $tableCard": {
        flex: "1 1 auto",
        minHeight: 0,
      },
    },
    "@media (max-width:899.95px)": {
      paddingTop: "68px",
      height: "auto",
      minHeight: "var(--app-vh)",
    },
  },

  /* Explicit hook, rather than `& > div:last-child` which silently targets
     whatever element happens to render last. */
  tableCard: {
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
    "& > *": {
      flex: "1 1 auto",
      minHeight: 0,
    },
  },

  filtersBar: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
    padding: "12px 14px",
    marginBottom: 14,
    borderRadius: 10,
    backgroundColor: colors.surface,
    border: `1px solid ${colors.borderLight}`,
    flexShrink: 0,
  },

  /*
   * Auto-fit at a 170px floor: as many columns as the width allows, without a
   * breakpoint per layout, and never a single full-width control per row —
   * which is what pushes a table off a phone screen.
   */
  filtersGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(170px, 1fr))",
    gap: 10,
    "& .MuiFormControl-root": { minWidth: 0 },
  },

  quickFilters: {
    alignItems: "center",
    rowGap: 6,
  },

  quickLabel: {
    fontSize: 12,
    color: colors.secondaryTextColor,
    whiteSpace: "nowrap",
  },

  filtersFooter: {
    justifyContent: "flex-end",
    minHeight: 24,
  },

  resultCount: {
    fontSize: 12.5,
    color: colors.secondaryTextColor,
    fontVariantNumeric: "tabular-nums",
  },
});

export default useStyles;
